import * as React from "react";
const SvgOffLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.93 5.236a1 1 0 0 1-.48 1.33 6 6 0 1 0 5.143.02 1 1 0 1 1 .866-1.801 8 8 0 1 1-6.86-.028 1 1 0 0 1 1.331.48M12 3c.553 0 1 .407 1 .91v8.18c0 .503-.447.91-1 .91s-1-.407-1-.91V3.91c0-.503.448-.91 1-.91", clipRule: "evenodd" }));
export default SvgOffLine;
